import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import React, { useContext, useState, useEffect } from 'react'
import { ResponsiveContext } from '../libs/contexts/responsiveContext'
import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { styled } from '@mui/material/styles'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { logout } from '../store/actions/authActions'
import { drawerWidth } from '../theme/theme'
import { useTheme } from '@mui/material/styles'
import { useMediaQuery } from '@mui/material'
import { AuthContext } from '../libs/contexts/authContext'

const openedMixin = (theme, isMobile) => {
  return {
    width: isMobile ? '100vw' : drawerWidth,
    height: '100vh',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
  }
}

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(4)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(5)} + 1px)`,
  },
  [theme.breakpoints.down('sm')]: {
    width: 0,
  },
})

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacing(2),
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}))

const StyledDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  return {
    width: isMobile ? '100vw' : drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    position: isMobile ? 'fixed' : 'relative',
    zIndex: theme.zIndex.drawer,
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme, isMobile),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }
})

const ContactSupportButton = () => (
  <a
    href="https://support.afficiency.com/knowledge/how-do-i-get-help-about-an-application-agent-set-up-or-platform-issues"
    target="_blank"
    rel="noreferrer"
    style={{ all: 'unset' }}
  >
    <Button
      color="primary"
      sx={{
        textTransform: 'none',
        padding: '10px 24px',
        backgroundColor: '#C4CAF1',
        borderRadius: '100px',
        width: '240px',
      }}
    >
      Contact Support
    </Button>
  </a>
)

const FAQButton = ({company}) => (
  <a
    href={
      company && company === 'foresters'
        ? 'https://www.afficiency.com/lwp-application-management-portal-faqs-0-0'
        : 'https://www.afficiency.com/sbli-application-management-portal-faqs'
    }
    target="_blank"
    rel="noreferrer"
    style={{ all: 'unset' }}
  >
    <Button
      color="primary"
      sx={{
        textTransform: 'none',
        padding: '10px 24px',
        backgroundColor: '#C4CAF1',
        borderRadius: '100px',
        width: '240px',
      }}
    >
      Frequently Asked Questions
    </Button>
  </a>
)

const Sidebar = ({ open, toggleDrawer }) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { pathname, search } = useLocation()
  const { authObj, company, logout: context_logout, affiliateCode } = useContext(AuthContext)
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const loggedIn = useSelector((state) => state.auth.isAuthenticated)
  const relationalType = useSelector((state) => state.auth.relationalType)
  const [tabs, setTabs] = useState([])

  const RELATIONAL_TYPE = company === 'foresters' || company === 'avant' ? authObj.relationalType : relationalType

  console.log('compny: ', company)
  console.log('RELATIONAL_TYPE: ', RELATIONAL_TYPE)

  useEffect(() => {
    setTabs(
      RELATIONAL_TYPE === 87 || RELATIONAL_TYPE == null
        ? company === 'foresters'
          ? [
              { text: 'Home', to: '/' },
              // { text: 'Dashboard', to: '/dashboard' },
              // { text: 'Scorecard', to: '/scorecard' },
              { text: 'Application Management', to: '/application-management' },
            ]
          : company === 'avant'
          ? [
              { text: 'Home', to: `/` },
              // { text: 'Dashboard', to: '/dashboard' },
              // { text: 'Scorecard', to: '/scorecard' },
              { text: 'Application Management', to: `/application-management` },
              { text: 'Commissions', to: `/commissions` },
              { text: 'Product Information & Training', to: `/productInformation` },
              { text: 'Producer Profile', to: `/profile` },
            ]
          : [
              { text: 'Home', to: `/` },
              // { text: 'Dashboard', to: '/dashboard' },
              // { text: 'Scorecard', to: '/scorecard' },
              { text: 'Application Management', to: `/application-management` },
            ]
        : [
            { text: 'Dashboard', to: '/dashboard' },
            { text: 'Scorecard', to: '/scorecard' },
            { text: 'Application Management', to: '/application-management' },
          ]
    )
  }, [relationalType, loggedIn, authObj.isAuthenticated])

  // const isAuthRoute = pathname === '/login' || pathname === '/register'
  // if (isAuthRoute) {
  //   toggleDrawer(false)
  //   return null
  // }
  const handleLogin = () => {
    company === 'foresters'
      ? search
        ? navigate(`/login/${search}`)
        : navigate('/login')
      : navigate(`/login?affiliateCode=${affiliateCode}`)
  }

  const handleLogout = () => {
    company === 'foresters' || company === 'avant' ? context_logout() : dispatch(logout())
    navigate(`/login${search}`)
  }

  // const tabs = (relationalType !== 87 || relationalType == null) ? [
  //   { text: 'Home', to: '/' },
  //   { text: 'Dashboard', to: '/dashboard' },
  //   { text: 'Scorecard', to: '/scorecard' },
  //   { text: 'Application Management', to: '/application-management' },
  // ] :
  // [
  // { text: 'Home', to: '/' },
  //   // { text: 'Dashboard', to: '/dashboard' },
  //   // { text: 'Scorecard', to: '/scorecard' },
  // { text: 'Application Management', to: '/application-management' },
  // ]

  return (
    <StyledDrawer variant="permanent" open={open}>
      <IconButton
        sx={{
          display: 'inline-flex',
          border: '2px solid #3C4FB9',
          padding: 0,
          borderRadius: '25px',
          marginLeft: 'auto',
          marginRight: '8px',
          mt: 4,
        }}
        onClick={() => toggleDrawer(!open)}
      >
        {!open ? <ChevronRightIcon color="primary" /> : <ChevronLeftIcon color="primary" />}
      </IconButton>
      <List sx={{ display: open ? 'block' : 'none', marginTop: '50px', mx: 2 }}>
        {tabs.map(({ text, to }, idx) => {
          const selected = to.substring(1) === pathname.substring(1)
          let disabled = false
          return (
            <ListItemButton
              key={`${text}_${idx}`}
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
                border: selected ? '1px solid transparent' : 'none',
                borderRadius: selected ? '8px' : '0px',
                backgroundColor: selected && '#E7EAFC',
              }}
              onClick={() => navigate(to, { state: { ...location.state, affiliateCode: affiliateCode } })}
              disabled={disabled}
            >
              <ListItemText
                primary={text}
                sx={{
                  color: (theme) => (selected ? theme.palette.primary.main : theme.palette.grey[600]),
                }}
              />
            </ListItemButton>
          )
        })}
      </List>
      <Box
        sx={{
          display: open ? 'flex' : 'none',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '144px',
          marginTop: isSmallScreen ? '400px' : 'auto',
          marginBottom: 10,
          rowGap: '25px',
        }}
      >
        {isSmallScreen && <ContactSupportButton />}
        {isSmallScreen && <FAQButton company = {company} />}
        <Button
          color="primary"
          sx={{
            padding: '10px 24px',
            backgroundColor: '#C4CAF1',
            borderRadius: '100px',
            letterSpacing: '.1px',
            width: '240px',
          }}
          disabled
        >
          <Typography>
            Share your feedback <br />
          </Typography>
        </Button>
        <Divider sx={{ width: '61.8%' }} />
        {loggedIn || authObj.isAuthenticated ? (
          <Button
            color="primary"
            sx={{
              padding: '10px 24px',
              border: '1px solid #3C4FB9',
              borderRadius: '100px',
            }}
            onClick={handleLogout}
          >
            Log Out
          </Button>
        ) : (
          <Button
            color="primary"
            sx={{
              padding: '10px 24px',
              border: '1px solid #3C4FB9',
              borderRadius: '100px',
            }}
            onClick={handleLogin}
          >
            Login
          </Button>
        )}
      </Box>
    </StyledDrawer>
  )
}

export default Sidebar
